import type { ReactNode } from 'react';
import { AccionesRapidas } from './AccionesRapidas';
import estilos from './CabeceraPagina.module.css';

interface CabeceraPaginaProps {
  titulo: string;
  /** Explica en una línea qué se ve en esta pantalla. */
  descripcion?: string;
  acciones?: ReactNode;
}

/** Cabecera de una pantalla: título, explicación y acciones principales. */
export function CabeceraPagina({ titulo, descripcion, acciones }: CabeceraPaginaProps) {
  return (
    <header className={estilos.cabecera}>
      <div className={estilos.titulo}>
        <h2>{titulo}</h2>
        {descripcion && <p className={estilos.descripcion}>{descripcion}</p>}
      </div>
      {/* Las acciones de la pantalla quedan a la izquierda del trío, que va pegado al borde. */}
      {acciones && <div className={estilos.acciones}>{acciones}</div>}
      <AccionesRapidas />
    </header>
  );
}
